module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/client-list/client-list.component.scss
// module id = ./src/app/clients/client-list/client-list.component.scss
// module chunks = main